module.exports = __webpack_public_path__ + "static/media/image 2 (1).90ea6e5a.png";